import * as React from 'react'
import { Redirect, Route, RouteProps } from 'react-router'
import config from '../config'
import { PermissionDeniedNotice } from './PermissionDeniedNotice'

interface Props extends RouteProps {
  isPermissionGranted?: boolean
}

export function RestrictedRoute({ isPermissionGranted, ...routeProps }: Props) {
  if (!isPermissionGranted) {
    return <Route {...routeProps} component={PermissionDeniedNotice} />
  }

  if (!config.user.onboarded) {
    return <Redirect to={{ pathname: '/onboarding/shopgoodwill' }} />
  }

  return <Route {...routeProps} />
}
